import React from "react"
import { graphql } from "@apollo/client/react/hoc"
import TabbedListingPage from "../Material/TabbedListingPage"
import { HasPermissionsQuery } from "../Functions/querys"
import CarIssueContainer from "./Issues/CarIssueContainer"
import JobContainer from "./Jobs/JobContainer"
import WorkorderContainer from "./WorkOrders/WorkorderContainer"
import ReportsPanel from "../Reports/ReportsPanel"
import { ROUTES } from "../Layout/routes"

// All three panels self-supply location/navigate via their own withApolloClient
// wrap, so the only thing each actually reads off props is currentUser. Reports
// needs neither -- ReportsPanel owns its own date range, filters and view state.
const maintenanceTabs = [
    { id: "issues", name: "Car Issues", iconClassName: "fa fa-cog", permissionRequired: "view_carissues", render: ({ currentUser }) => <CarIssueContainer currentUser={currentUser} /> },
    { id: "jobs", name: "Maintenance Jobs", iconClassName: "fa fa-cogs", permissionRequired: "view_job", render: ({ currentUser }) => <JobContainer currentUser={currentUser} /> },
    { id: "work_order", name: "Work Order", iconClassName: "fa fa-wrench", permissionRequired: "view_workorder", render: ({ currentUser }) => <WorkorderContainer currentUser={currentUser} /> },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, permissionRequired: null, render: () => <ReportsPanel reportId="maintenance" /> },
]

const MaintenancePage = (props) => (
    <TabbedListingPage
        className="maintenancePage"
        route={ROUTES.maintenance}
        tabs={maintenanceTabs.map(tab => ({ ...tab, render: () => tab.render({ currentUser: props.currentUser }) }))}
        hasPermissions={props.hasPermissions}
        loading={props.loading}
    />
)

export { maintenanceTabs }

export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["view_carissues", "view_job", "view_workorder"] } }),
    props: ({ data: { hasPermissions, loading } }) => ({ hasPermissions, loading }),
})(MaintenancePage)
